import * as THREE from 'three';

export class AntEye {
  readonly camera = new THREE.PerspectiveCamera(68, 1, .025, 400);
  active = false;
  yaw = 0;
  pitch = -.06;
  private pointer: number | null = null;
  private x = 0;
  private y = 0;
  private unlockedAt = -Infinity;
  constructor(private readonly canvas: HTMLCanvasElement, enabled: () => boolean) {
    this.camera.layers.enable(1);
    const release = () => { this.pointer = null; };
    canvas.addEventListener('pointerdown', e => {
      if (!this.active || !enabled() || e.button !== 0) return;
      this.pointer = e.pointerId; this.x = e.clientX; this.y = e.clientY;
      canvas.setPointerCapture(e.pointerId);
      if (e.pointerType === 'mouse' && !e.shiftKey && document.pointerLockElement !== canvas) {
        try {
          Promise.resolve(canvas.requestPointerLock()).then(() => {
            if (!this.active || !enabled()) this.clear();
          }).catch(() => { /* Drag looking remains available when capture is unsupported. */ });
        } catch { /* Embedded browsers may only support drag looking. */ }
      }
    });
    canvas.addEventListener('pointermove', e => {
      if (document.pointerLockElement === canvas || e.pointerId !== this.pointer || !this.active || !enabled()) return;
      this.yaw -= (e.clientX - this.x) * .004;
      this.pitch = THREE.MathUtils.clamp(this.pitch - (e.clientY - this.y) * .004, -1.05, 1.2);
      this.x = e.clientX; this.y = e.clientY;
    });
    canvas.addEventListener('pointerup', release); canvas.addEventListener('pointercancel', release);
    canvas.addEventListener('lostpointercapture', release); window.addEventListener('blur', release);
    document.addEventListener('mousemove', e => {
      if (document.pointerLockElement !== canvas || !this.active || !enabled()) return;
      this.yaw -= e.movementX * .003;
      this.pitch = THREE.MathUtils.clamp(this.pitch - e.movementY * .003, -1.05, 1.2);
    });
    document.addEventListener('pointerlockchange', () => {
      if (document.pointerLockElement !== canvas) { this.unlockedAt = performance.now(); release(); }
    });
    document.addEventListener('visibilitychange', () => { if (document.hidden) this.clear(); });
  }
  clear(): void { this.pointer = null; if (document.pointerLockElement === this.canvas) document.exitPointerLock(); }
  releaseLook(): boolean {
    const captured = document.pointerLockElement === this.canvas || performance.now() - this.unlockedAt < 250;
    if (captured) this.clear();
    return captured;
  }
  resize(aspect: number): void { this.camera.aspect = aspect; this.camera.updateProjectionMatrix(); }
  update(position: THREE.Vector3): void {
    this.camera.position.set(position.x, position.y + .62, position.z);
    this.camera.rotation.set(this.pitch, this.yaw, 0, 'YXZ'); this.camera.updateMatrixWorld();
  }
}
